// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3QlII","label":"SetPasswdForm_label__3RW1D"};